import brcast from 'brcast';
import {memo, useEffect} from 'react';
import {useUplusUserAgent} from '@/hooks';
import {runAndroidBackHandlers} from './useAndroidBackHandler';

const broadcast = brcast();

window.androidBackPress = () => {
  broadcast.setState({event: 'androidBackPress'});
};

const detectAndroid = (): {
  isAndroid: boolean;
  version: string | null;
} => {
  const userAgent = navigator.userAgent;
  const isAndroid = /Android/i.test(userAgent);
  const androidVersionMatch = userAgent.match(/Android\s([0-9.]+)/i);
  const version = androidVersionMatch ? androidVersionMatch[1] : 'Unknown';

  return {
    isAndroid,
    version,
  };
};

function AndroidBackHandler() {
  const isUplusApp = useUplusUserAgent();
  const {isAndroid} = detectAndroid();
  const isAndroidUplus = isUplusApp && isAndroid;

  useEffect(() => {
    const id = broadcast.subscribe((state: any) => {
      if (isAndroidUplus && state?.event === 'androidBackPress') {
        const handled = runAndroidBackHandlers();

        if (!handled) {
          if (typeof window !== 'undefined' && window.soho) {
            window.soho.postMessage(
              JSON.stringify({type: 'navigateHome', from: 'myfc'})
            );
          }
        }
      }
    });
    return () => {
      broadcast.unsubscribe(id);
    };
  }, [isAndroidUplus]);

  return null;
}

export default memo(AndroidBackHandler);
